export const ADMIN_NOTIFICATION_USER_ID = 1;

export const DEFAULT_FILTERS = {
  search: "",
  category: "all",
  sort: "recent",
  perPage: 12,
};

export const NOTIFICATION_CATEGORIES = [
  {
    value: "all",
    label: "Toutes",
    keywords: [],
  },
  {
    value: "profil",
    label: "Profil",
    keywords: ["profil", "fiche", "compte", "acteur", "avatar"],
  },
  {
    value: "event",
    label: "Événement",
    keywords: [
      "événement",
      "evenement",
      "event",
      "compétition",
      "competition",
      "stage",
      "calendrier",
      "inscription",
    ],
  },
  {
    value: "subscription",
    label: "Souscription",
    keywords: [
      "souscrire",
      "souscription",
      "abonnement",
      "formule",
      "stripe",
      "paiement",
      "achat",
      "coach pro",
      "coach ultim",
    ],
  },
  {
    value: "group",
    label: "Groupe",
    keywords: ["groupe", "group", "coach"],
  },
  {
    value: "user",
    label: "Utilisateur",
    keywords: [
      "utilisateur",
      "user",
      "adhérent",
      "adherent",
      "judoka",
      "inscrit",
      "inscription",
    ],
  },
  {
    value: "message",
    label: "Message",
    keywords: ["message", "contact", "formulaire", "mail", "email"],
  },
  {
    value: "other",
    label: "Autres",
    keywords: [],
  },
];

export const CATEGORY_STYLES = {
  profil: {
    badge:
      "bg-violet-100 text-violet-700 dark:bg-violet-500/10 dark:text-violet-200",
    dot: "bg-violet-500",
  },
  event: {
    badge:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
    dot: "bg-emerald-500",
  },
  subscription: {
    badge:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
    dot: "bg-amber-500",
  },
  group: {
    badge: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    dot: "bg-sky-500",
  },
  user: {
    badge:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200",
    dot: "bg-indigo-500",
  },
  message: {
    badge: "bg-rose-100 text-rose-700 dark:bg-rose-500/10 dark:text-rose-200",
    dot: "bg-rose-500",
  },
  other: {
    badge:
      "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white/60",
    dot: "bg-slate-400",
  },
};

export function normalizeText(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function formatNotificationDate(value) {
  if (!value) return "Date inconnue";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "Date inconnue";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function getNotificationCategory(notification) {
  const message = normalizeText(notification?.message);

  const foundCategory = NOTIFICATION_CATEGORIES.find((category) => {
    if (["all", "other"].includes(category.value)) return false;

    return category.keywords.some((keyword) =>
      message.includes(normalizeText(keyword)),
    );
  });

  return foundCategory?.value || "other";
}

export function getCategoryLabel(value) {
  return (
    NOTIFICATION_CATEGORIES.find((category) => category.value === value)
      ?.label || "Autres"
  );
}

export function getCategoryStyle(value) {
  return CATEGORY_STYLES[value] || CATEGORY_STYLES.other;
}

export function enrichNotifications(notifications = []) {
  return notifications.map((notification) => ({
    ...notification,
    category: getNotificationCategory(notification),
  }));
}

export function filterNotifications(notifications = [], filters = DEFAULT_FILTERS) {
  const search = normalizeText(filters.search);
  const category = filters.category || "all";

  return notifications.filter((notification) => {
    const message = normalizeText(notification.message);

    const matchesSearch = !search || message.includes(search);
    const matchesCategory =
      category === "all" || notification.category === category;

    return matchesSearch && matchesCategory;
  });
}

export function sortNotifications(notifications = [], sort = "recent") {
  return [...notifications].sort((a, b) => {
    const dateA = new Date(a.created_at || 0).getTime();
    const dateB = new Date(b.created_at || 0).getTime();

    if (sort === "oldest") return dateA - dateB;

    return dateB - dateA;
  });
}

export function paginateItems(items = [], page = 1, perPage = 12) {
  const safePerPage = Number(perPage || 12);
  const totalPages = Math.max(Math.ceil(items.length / safePerPage), 1);
  const safePage = Math.min(Math.max(Number(page || 1), 1), totalPages);
  const start = (safePage - 1) * safePerPage;

  return {
    page: safePage,
    totalPages,
    items: items.slice(start, start + safePerPage),
  };
}

export function buildNotificationStats(notifications = []) {
  const stats = {
    total: notifications.length,
    profil: 0,
    event: 0,
    subscription: 0,
    group: 0,
    user: 0,
    message: 0,
    other: 0,
  };

  notifications.forEach((notification) => {
    const category = notification.category || "other";
    stats[category] = (stats[category] || 0) + 1;
  });

  return stats;
}